var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_vm.transactionId)),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "md-table",
          [
            _c(
              "md-table-row",
              [
                _c("md-table-head", [_vm._v("No Of Users")]),
                _c("md-table-head", [_vm._v("No Of Admins")]),
                _c("md-table-head", [_vm._v("No Of Stops")]),
                _c("md-table-head", [_vm._v("No Of Vehicles")]),
                _c("md-table-head", [_vm._v("No Of Gps Units")]),
                _c("md-table-head", [_vm._v("Term")]),
                _c("md-table-head", [_vm._v("Billing Plan")]),
              ],
              1
            ),
            _vm._l(_vm.items, function (item, itemIndex) {
              return _c(
                "md-table-row",
                { key: "details-" + itemIndex },
                [
                  _c(
                    "md-table-cell",
                    [
                      !item.noOfUsers && !item.userLicenseFee
                        ? [
                            _vm._v(
                              "\n                        -\n                    "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.noOfUsers) +
                                "\n                        x " +
                                _vm._s(_vm.currency) +
                                "\n                        " +
                                _vm._s(
                                  _vm.formatNumber(item.userLicenseFee, 2)
                                ) +
                                "\n                    "
                            ),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "md-table-cell",
                    [
                      !item.noOfAdmins && !item.adminLicenseFee
                        ? [
                            _vm._v(
                              "\n                        -\n                    "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.noOfAdmins) +
                                "\n                        x " +
                                _vm._s(_vm.currency) +
                                "\n                        " +
                                _vm._s(
                                  _vm.formatNumber(item.adminLicenseFee, 2)
                                ) +
                                "\n                    "
                            ),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "md-table-cell",
                    [
                      !item.noOfStops && !item.stopLicenseFee
                        ? [
                            _vm._v(
                              "\n                        -\n                    "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.noOfStops) +
                                "\n                        x " +
                                _vm._s(_vm.currency) +
                                "\n                        " +
                                _vm._s(
                                  _vm.formatNumber(item.stopLicenseFee, 2)
                                ) +
                                "\n                    "
                            ),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "md-table-cell",
                    [
                      !item.noOfVehicles && !item.vehicleUnitPrice
                        ? [
                            _vm._v(
                              "\n                        -\n                    "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.noOfVehicles) +
                                "\n                        x " +
                                _vm._s(_vm.currency) +
                                "\n                        " +
                                _vm._s(
                                  _vm.formatNumber(item.vehicleUnitPrice, 2)
                                ) +
                                "\n                    "
                            ),
                          ],
                    ],
                    2
                  ),
                  _c(
                    "md-table-cell",
                    [
                      !item.NoOfGpsUnits && !item.servicePrice
                        ? [
                            _vm._v(
                              "\n                        -\n                    "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                        " +
                                _vm._s(item.NoOfGpsUnits) +
                                "\n                        x " +
                                _vm._s(_vm.currency) +
                                "\n                        " +
                                _vm._s(_vm.formatNumber(item.servicePrice, 2)) +
                                "\n                    "
                            ),
                          ],
                    ],
                    2
                  ),
                  _c("md-table-cell", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.term) +
                        "\n                "
                    ),
                  ]),
                  _c("md-table-cell", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(item.billingPlan) +
                        "\n                "
                    ),
                  ]),
                ],
                1
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }